<template>
	<div id="page">
		<div class="page-content">
			<div class="page-title page-title-small">
				<h2><button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>اپلیکیشن تسکینو</h2>
				<button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
			</div>
			<div class="card header-card shape-rounded" data-card-height="150">
				<div class="card-overlay bg-highlight opacity-95"></div>
				<div class="card-overlay dark-mode-tint"></div>
				<div class="card-bg bg-20"></div>
			</div>

			<div class="card card-style text-center landingPage-titleDiv mb-2">
				<div class="content">
					<h4 class="font-700 m-0">اپلیکیشن تسکینو <span v-if="isMinVersion==true">- نسخه اشتراکی</span></h4>
					<p class="font-12 mt-2 color-highlight">نسخه شماره {{appVersionCode}}</p>
				</div>
			</div>

			<div class="text-center bg-transparent mt-2">
				<label class="landingPage-userTitle font-900 mb-0 color-highlight">{{UserFullName}}</label>

				<p v-if="isMinVersion==true" class="font-11 mb-1">اعتبار حساب کاربری تا تاریخ: <b class="d-inline-block ltr">{{expireDate}}</b></p>
				<p class="font-14 mb-1">امروز: {{todayDate}}</p>

				

				<div class="row mx-3 mb-2 justify-content-center landingPage-mainDiv">
					<router-link to="/About" class="col-4 p-1">
						<div class="box">
							<i class="fa fa-info-circle color-magenta1-light"></i>
							<p class="font-700 mb-0 mt-2">درباره</p>
						</div>
					</router-link>

					<button data-menu="HelpMenu" class="col-4 p-1 bg-transparent">
						<div class="box">
							<i class="fa fa-question-circle color-pink2-light"></i>
							<p class="font-700 mb-0 mt-2">راهنما</p>
						</div>
					</button>
					<router-link to="/PrivacyPolicy" class="col-4 p-1">
						<div class="box">
							<i class="fa fa-shield-alt color-magenta2-light"></i>
							<p class="font-700 mb-0 mt-2">سیاست حفظ حریم‌ خصوصی</p>
						</div>
					</router-link>
					<template v-if="isMinVersion==true">
						<router-link to="/Order" class="col-4 p-1" v-if="isAdmin==true || isFreeRegist">
							<div class="box">
								<i class="fa fa-user-clock color-red1-light"></i>
								<p class="font-700 mb-0 mt-2">تمدید اشتراک</p>
							</div>
						</router-link>
						<router-link to="/UserOrder" v-if="isAdmin==false" class="col-4 p-1">
							<div class="box">
								<i class="fa fa-user-clock color-red1-light"></i>
								<p class="font-700 mb-0 mt-2">تمدید اشتراک</p>
							</div>
						</router-link>
						<router-link to="/SmsRecharge" class="col-4 p-1">
							<div class="box">
								<i class="fa fa-envelope-open-text color-pink2-light"></i>
								<p class="font-700 mb-0 mt-2">پیامک اطلاع رسانی</p>
							</div>
						</router-link>
					</template>
					<router-link to="/LocalUserList" class="col-4 p-1" v-if="isAdmin==true && isFreeRegist!==true">
						<div class="box">
							<i class="fa fa-users color-red1-light"></i>
							<p class="font-700 mb-0 mt-2">لیست کاربران</p>
						</div>
					</router-link>
					<router-link to="/OrgUnitReport" class="col-4 p-1" v-if="TaskAccess=='1'">
						<div class="box">
							<i class="fa fa-chart-pie color-green1-light"></i>
							<p class="font-700 mb-0 mt-2">وضعیت {{lableText('TasksName')??'وظایف'}}</p>
						</div>
					</router-link>
					<router-link to="/ReminderList" class="col-4 p-1">
						<div class="box">
							<i class="fa fa-bell color-red1-light"></i>
							<p class="font-700 mb-0 mt-2">یادآورها</p>
						</div>
					</router-link>
					<router-link to="/UpdatesPage" class="col-4 p-1">
						<div class="box">
							<i class="fa fa-bullhorn color-blue-light"></i>
							<p class="font-700 mb-0 mt-2">بروزرسانی‌ها</p>
						</div>
					</router-link>
					<router-link to="/TaskCloseRequestList" class="col-4 p-1" v-if="TaskAccess=='1'">
						<div class="box">
							<i class="fa fa-folder-open color-orange-dark"></i>
							<p class="font-700 mb-0 mt-2">کارتابل</p>
						</div>
					</router-link>
					<router-link to="/InviteUser" class="col-4 p-1" v-if="isMinVersion==true">
						<div class="box">
							<i class="fa fa-folder-open color-orange-dark"></i>
							<p class="font-700 mb-0 mt-2">دعوت از دوستان و همکاران</p>
						</div>
					</router-link>
					<router-link to="/OrgJobList" class="col-4 p-1" v-if="isAdmin==true && isFreeRegist!==true">
						<div class="box">
							<i class="fa fa-sitemap color-yellow2-dark"></i>
							<p class="font-700 mb-0 mt-2">چارت سازمانی</p>
						</div>
					</router-link>

					<router-link v-if="PersonAccess=='1' && isMinVersion==false" to="/PersonList" class="col-4 p-1">
						<div class="box">
							<i class="fa fa-users color-blue1-light"></i>
							<p class="font-700 mb-0 mt-2">اشخاص و موسسات</p>
						</div>
					</router-link>
					<router-link v-if="TaskTypeAccess=='1'|| (isMinVersion==true && isFreeRegist!==true)" to="/TaskTypeList" class="col-4 p-1">
						<div class="box">
							<i class="fa fa-check-circle color-blue2-dark"></i>
							<p class="font-700 mb-0 mt-2">{{lableText('TaskType')??'نوع وظیفه'}}</p>
						</div>
					</router-link>
					<router-link v-if="OtherWorkTypeAccess=='1' || ( isMinVersion==true && isFreeRegist!==true)" to="/OtherWorkTypeList" class="col-4 p-1">
						<div class="box">
							<i class="fa fa-check-square color-magenta2-light"></i>
							<p class="font-700 mb-0 mt-2">نوع فعالیت</p>
						</div>
					</router-link>
					<router-link to="/TaskNoteList" class="col-4 p-1" v-if="isFreeRegist!==true">
						<div class="box">
							<i class="fa fa-sticky-note color-pink1-dark"></i>
							<p class="font-700 mb-0 mt-2">یادداشت های من</p>
						</div>
					</router-link>
					<router-link to="/WorkTimerList" class="col-4 p-1" v-if="isFreeRegist!==true">
						<div class="box">
							<i class="fa fa-stopwatch color-green1-light"></i>
							<p class="font-700 mb-0 mt-2">زمان سنج (تایمر)</p>
						</div>
					</router-link>
					<router-link to="/NoticeMassageUserList" class="col-4 p-1">
						<div class="box">
							<i class="fa fa-list-alt color-orange-dark"></i>
							<p class="font-700 mb-0 mt-2">تابلو اعلانات</p>
						</div>
					</router-link>
					<router-link to="/VacationList" class="col-4 p-1">
						<div class="box">
							<i class="fa fa-briefcase color-pink2-dark"></i>
							<p class="font-700 mb-0 mt-2">درخواست مرخصی</p>
						</div>
					</router-link>
					<router-link to="/WorkGroupList" class="col-4 p-1">
						<div class="box">
							<i class="fa fa-users color-blue-light"></i>
							<p class="font-700 mb-0 mt-2">کارگروه</p>
						</div>
					</router-link>
					<router-link to="/UserPresenceList" class="col-4 p-1" v-if="isFreeRegist!==true">
						<div class="box">
							<i class="fa fa-street-view color-mint-dark"></i>
							<p class="font-700 mb-0 mt-2">حضور و غیاب</p>
						</div>
					</router-link>
					<router-link to="/showUsersonMap" class="col-4 p-1" v-if="isFreeRegist!==true">
						<div class="box">
							<i class="fa fa-map-marked-alt color-green2-dark"></i>
							<p class="font-700 mb-0 mt-2"> موقعیتها در نقشه</p>
						</div>
					</router-link>
					<router-link to="/NotificationList" class="col-4 p-1">
						<div class="box">
							<div class="position-relative d-flex">
								<i class="fa fa-comment-alt color-yellow1-light"></i>
								<span class="badge bg-red1-dark badge-NotificationCount" v-if="NotificationCount>0">{{NotificationCount}}</span>
							</div>
							<p class="font-700 mb-0">پیام ها</p>
						</div>
					</router-link>
					<router-link to="/UserProfile" class="col-4 p-1" v-if="isMinVersion==true">
						<div class="box">
							<i class="fa fa-user-circle color-green1-dark"></i>
							<p class="font-700 mb-0 mt-2">پروفایل کاربری</p>
						</div>
					</router-link>
					<router-link to="/ChangePass" class="col-4 p-1" v-if="isFreeRegist!==true">
						<div class="box">
							<i class="fa fa-lock color-orange-dark"></i>
							<p class="font-700 mb-0 mt-2">تغییر رمز عبور</p>
						</div>
					</router-link>
					<router-link to="/AppUpdate" class="col-4 p-1" v-if="this.isFreeVersion==false">
						<div class="box">
							<i class="fa fa-download color-magenta1-dark"></i>
							<p class="font-700 mb-0 mt-2">دانلود آخرین نسخه</p>
						</div>
					</router-link>

					<a class="col-4 p-1" @click.prevent="SignOutUser()">
						<div class="box">
							<i class="fa fa-sign-out-alt color-red1-dark"></i>
							<p class="font-700 mb-0 mt-2">خروج</p>
						</div>
					</a>
				</div>



			</div>
		</div>

		<Help-Menu title="معرفی موبایل اپلیکیشن تسکینو" keyEn="TaskOnline_Help"></Help-Menu>
	</div>
</template>

<script>
	import HelpMenu from '../Components/HelpMenu.vue';
	export default {
		components: {
			"Help-Menu": HelpMenu
		},
		data() {
			return {
				showInBazar: false,
				info: null,
				todayDate: null,
				expireDate: null
			}
		},
		computed: {
			IsUserAuthenticated() {
				return this.$store.getters.IsUserAuthenticated;
			},
			UserFullName() {
				return this.$store.getters.GetUserFullName;
			},
			isAdmin() {
				return this.$store.getters.GetIsAdmin;
			},
			isFreeRegist() {
				return this.$store.getters.GetIsFreeRegist;
			},
			NotificationCount() {
				return this.$store.getters.GetNotificationCount;
			},
			PersonAccess() {
				return this.$store.getters.GetPersonAccess;
			},
			TaskAccess() {
				return this.$store.getters.GetTaskAccess;
			},
			OtherWorkTypeAccess() {
				return this.$store.getters.GetOtherWorkTypeAccess;
			},
			TaskTypeAccess() {
				return this.$store.getters.GetTaskTypeAccess;
			},

		},
		methods: {
			GetCurrentDate() {
				this.$http.get("Account/GetCurrenctDateTime")
					.then(data => {
						this.todayDate = data.data;

					});
			},
			GetExpireDate() {
				this.$http.get("Account/GetUserExpireDate")
					.then(data => {
						this.expireDate = data.data;

					});
			},
			loadScriptsLanding() {///هرجا به مشکل لود نشدن کاستوم جی اس خوردید این فانگشن رو در سمت متدد اون صفحه بارید و در قسمت کرییت فانگشن رو کال کنید.
				let recaptchaScript = document.createElement("script");
				recaptchaScript.setAttribute("id", "customjsScript")
				recaptchaScript.setAttribute("src", "./assets/scripts/custom.js");
				var exist = document.getElementById("customjsScript");
				if (exist) {
					exist.remove();
				}

				document.head.appendChild(recaptchaScript);
			},
			SignOutUser() {
				this.$store.dispatch("SignOutUser");
			},
			GetAccesses() {
				this.$store.dispatch("GetTaskTypeAccessFromServer");
				this.$store.dispatch("GetOtherWorkTypeAccess");
				this.$store.dispatch("GetPersonAccess");
			},

		},
		created() {
			
			this.loadScriptsLanding();
			//this.$http
			//	.get("Task/GetPayInBazar")
			//	.then((data) => {
			//		var res = data.data;
			//		this.showInBazar = res.isSuccess;
			//	});
			this.GetCurrentDate();
			this.GetExpireDate();
			this.GetAccesses();

		},
		mounted() {
			document
				.querySelectorAll(".menu-box-right")
				.forEach((a) => (a.style.display = "block"));
		},

	}
</script>